import { packageDataService } from '../api/packages-service.js';
import { packageDetailsModal } from '../utils/package-modal.js';

let packageData = {};
let testimonialsData = [];
let rawPackageData = {}; // Store the original package data for modal

document.addEventListener('DOMContentLoaded', async () => {
    try {
        // Show loading state
        showLoadingState();
        
        // Fetch data from Google Sheets API and static testimonials
        const [packages, testimonials] = await Promise.all([
            packageDataService.fetchPackageData(),
            fetch('/data/testimonials.json').then(res => res.json())
        ]);
        
        packageData = packages;
        rawPackageData = packages; // Store for modal access
        testimonialsData = testimonials;
        
        // Hide loading and render content
        hideLoadingState();
        ['slider-3star','slider-4star','slider-5star'].forEach(renderSlider);
        renderTestimonials();
        setupPackageNav();
        setupTestimonialsNav();
        
    } catch (error) {
        console.error('Error loading homepage data:', error);
        showErrorState();
    }
});

function showLoadingState() {
    ['slider-3star','slider-4star','slider-5star'].forEach(id => {
        const container = document.getElementById(id);
        if (container) {
            container.innerHTML = `
                <div class="loading-placeholder">
                    <div class="loading-spinner"></div>
                    <p>Loading packages...</p>
                </div>
            `;
        }
    });
}

function hideLoadingState() {
    // Loading states will be replaced by actual content in renderSlider
}

function showErrorState() {
    ['slider-3star','slider-4star','slider-5star'].forEach(id => {
        const container = document.getElementById(id);
        if (container) {
            container.innerHTML = `
                <div class="error-placeholder">
                    <i class="fas fa-exclamation-triangle"></i>
                    <p>Unable to load packages. Please try again later.</p>
                    <button class="btn btn-primary" onclick="location.reload()">Retry</button>
                </div>
            `;
        }
    });
}

// 2) Render function
function renderSlider(id) {
    const container = document.getElementById(id);
    if (!container) return;

    // Check if no packages are available for this category
    if (!packageData[id] || packageData[id].length === 0) {
        container.innerHTML = `
            <div class="no-packages-available">
                <div class="no-packages-content">
                    <i class="fas fa-luggage-cart"></i>
                    <h3>No Packages Available</h3>
                    <p>We're currently updating our ${id.replace('slider-', '').replace('star', ' star')} packages. Please check back soon or contact us for custom arrangements.</p>
                    <a href="/contact.html" class="btn btn-primary">Contact Us</a>
                </div>
            </div>
        `;
        return;
    }

    const imgPath = (img) => img.startsWith('/') ? img : '/src/assets/' + img;

    container.innerHTML = packageData[id].map((pkg, index) => {
        // build stars
        const filled = '<i class="fas fa-star"></i>'.repeat(pkg.star_rating || pkg.rating);
        const empty  = '<i class="far fa-star"></i>'.repeat(5 - (pkg.star_rating || pkg.rating));
        
        // Format price consistently
        const price = pkg.price || (typeof pkg.pricing?.[0]?.price === 'number' ? `£${pkg.pricing[0].price}` : '£600');
        
        return `
            <div class="package-card" data-package-id="${pkg.package_id}" data-slider="${id}" data-index="${index}">
                <div class="package-image">
                    <img src="${imgPath(pkg.img)}" alt="${pkg.title}">
                </div>
                <div class="package-content">
                    <div class="package-title-price">
                        <h3>${pkg.title}</h3>
                        <p class="price">${price}</p>
                    </div>
                    <div class="package-rating">
                        ${filled}${empty}
                        <span>${pkg.nights}</span>
                    </div>
                    <ul class="package-details">
                        ${pkg.details.map(d => `<li><i class="fas ${d.icon}"></i>${d.text}</li>`).join('')}
                    </ul>
                    <div class="package-buttons">
                        <a href="/contact.html" class="btn btn-primary">Enquire</a>
                        <button class="btn btn-link package-details-btn" data-package-id="${pkg.package_id}" data-slider="${id}" data-index="${index}">
                            Details <i class="fas fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    // Add event listeners for details buttons
    container.querySelectorAll('.package-details-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const sliderId = btn.dataset.slider;
            const index = parseInt(btn.dataset.index);
            const pkg = packageData[sliderId][index];
            
            if (pkg) {
                packageDetailsModal.show(pkg);
            }
        });
    });
}

function renderTestimonials() {
    const container = document.getElementById('testimonials-slider');
    if (!container || !testimonialsData.length) return;

    container.innerHTML = testimonialsData.map(review => `
        <div class="testimonial-card">
            <div class="testimonial-avatar">
                <div class="user-icon">
                    <i class="fas fa-user"></i>
                </div>
            </div>
            <h3>${review.name}</h3>
            <div class="testimonial-rating">
                ${'<i class="fas fa-star"></i>'.repeat(review.rating)}
                ${'<i class="far fa-star"></i>'.repeat(5 - review.rating)}
            </div>
            <p>${review.text}</p>
        </div>
    `).join('');
}

function setupPackageNav() {
    document.querySelectorAll('.packages-header').forEach(header => {
        const slider = header.nextElementSibling;
        const btnPrev = header.querySelector('.prev');
        const btnNext = header.querySelector('.next');
        const scrollAmt = slider.offsetWidth * 0.8;
        btnPrev.addEventListener('click', () => {
            slider.scrollBy({ left: -scrollAmt, behavior: 'smooth' });
        });
        btnNext.addEventListener('click', () => {
            slider.scrollBy({ left: scrollAmt, behavior: 'smooth' });
        });
    });
}

function setupTestimonialsNav() {
    const header = document.querySelector('.testimonials-header');
    if (!header) return;
    const slider = document.getElementById('testimonials-slider');
    const btnPrev = header.querySelector('.prev');
    const btnNext = header.querySelector('.next');
    if (!slider || !btnPrev || !btnNext) return;
    const scrollAmt = slider.offsetWidth * 0.8;
    btnPrev.addEventListener('click', () => {
        slider.scrollBy({ left: -scrollAmt, behavior: 'smooth' });
    });
    btnNext.addEventListener('click', () => {
        slider.scrollBy({ left: scrollAmt, behavior: 'smooth' });
    });
}

// Mobile menu toggle logic
const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
const mainNav = document.querySelector('.main-nav');
if (mobileMenuToggle && mainNav) {
  // Toggle menu on hamburger click
  mobileMenuToggle.addEventListener('click', (e) => {
    e.preventDefault();
    mainNav.classList.toggle('active');
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    if (!mobileMenuToggle.contains(e.target) && !mainNav.contains(e.target)) {
      mainNav.classList.remove('active');
    }
  });
}

// Calendly scroll button functionality
document.addEventListener('DOMContentLoaded', () => {
  const scrollBtn = document.querySelector('.calendly-scroll-btn');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const calendlyWidget = document.getElementById('calendly-widget');
      if (calendlyWidget) {
        calendlyWidget.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    });
  }
});


